import SHA256 from "crypto-js/sha256";

type CookieData = {
  utm_source: string;
  msisdn: string;
  mfs?: boolean;
};

export const setCookie = (
  utm_source: string,
  msisdn: string,
  mfs?: boolean,
): void => {
  console.log("setCookie", utm_source);
  clearAllCookies();
  const data: CookieData = { utm_source, msisdn, mfs };
  document.cookie = `data=${encodeURIComponent(
    JSON.stringify(data),
  )}; SameSite=Strict; path=/`;
};

export const clearAllCookies = (): void => {
  console.log("clearAllCookies");
  document.cookie.split(";").forEach((cookie: string) => {
    document.cookie = cookie
      .replace(/^ +/, "")
      .replace(/=.*/, "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;");
  });
};

export const getCookie = (name: string) => {
  try {
    // console.log("document.cookie", document.cookie);
    const cookies = document.cookie
      .split(";")
      .reduce((acc: { [key: string]: string }, cookie) => {
        const [key, value] = cookie.split("=");
        // console.log("key", key);
        // console.log("value", value);
        acc[key.trim()] = decodeURIComponent(value);
        return acc;
      }, {});
    // console.log("cookies[name]", JSON.parse(cookies[name]));
    return cookies[name] ? JSON.parse(cookies[name]) : null;
  } catch (e) {
    console.log("error", e);
    return null;
  }
};

// export const updateUtmValue = (utm_source: string) => {
//   if (
//     utm_source === "jazzT" ||
//     utm_source === "jazzG" ||
//     utm_source === "jazzM"
//   ) {
//     return "jazz";
//   } else {
//     return utm_source;
//   }
// };

export const sha256Hash = (value: string) => {
  return SHA256(value.trim().toLowerCase()).toString();
};

export const getPackageId = (qsPackageId: any, _package: string) => {
  // Default package id
  let finalId = "1";

  // Validate qsPackageId from query params
  if (qsPackageId === "1" || qsPackageId === "2" || qsPackageId === "3") {
    finalId = qsPackageId;
  }

  // Force "3" if the package type is POST
  if (_package.toLowerCase() === "post") {
    finalId = "3";
  }

  return finalId;
};

//Banner Images
const bannerImages: Record<string, string> = {
  ac: "https://cdn.econceptionscdn.com/Tamasha/imgs/Frame 1171276166.png",
  cricket: "https://cdn.econceptionscdn.com/Tamasha/imgs/asiacupcrik.webp",
  wcl: "https://cdn.econceptionscdn.com/Tamasha/imgs/wcl-generic-artwork.webp",
  asiacup: "https://cdn.econceptionscdn.com/Tamasha/imgs/asiacup.webp",
  epl: "https://cdn.econceptionscdn.com/Tamasha/imgs/epl.webp",
  epl2: "https://cdn.econceptionscdn.com/Tamasha/imgs/epl2.webp",
  trin: "https://cdn.econceptionscdn.com/Tamasha/imgs/tri-series-landing.webp",
  food: "https://cdn.econceptionscdn.com/Tamasha/imgs/Tamasha-Food.webp",
  bike: "https://cdn.econceptionscdn.com/Tamasha/imgs/bike.webp",
  gold: "https://cdn.econceptionscdn.com/Tamasha/imgs/gold.webp",
  watch: "https://cdn.econceptionscdn.com/Tamasha/imgs/watch.webp",
  imtiaz: "https://cdn.econceptionscdn.com/Tamasha/imgs/imtiaz.webp",
  khaadi: "https://cdn.econceptionscdn.com/Tamasha/imgs/Khaadi.webp",
  jdot: "https://cdn.econceptionscdn.com/Tamasha/imgs/Jdot.webp",
  psl: "https://cdn.econceptionscdn.com/Tamasha/imgs/wcl-generic-artwork.webp",
};

const DEFAULT_BANNER =
  "https://cdn.econceptionscdn.com/Tamasha/imgs/main-img.webp";

export const getBannerImage = (
  utm_campaign?: string,
  parameter?: string,
): string => {
  const campaignKey = utm_campaign?.toLowerCase();
  const paramKey = parameter?.toLowerCase();

  return (
    (campaignKey && bannerImages[campaignKey]) ||
    (paramKey && bannerImages[paramKey]) ||
    DEFAULT_BANNER
  );
};
